export enum companyRequirementsFormBuilderFormColumns {
  USED = 'used',
  NOT_USED = 'notUsed',
}
